import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';

export default class BtnWithText extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} x 
   * @param {number} y 
   */
  constructor(scene, x, y, bg, text, fontSize) {
    super(scene, x, y);

    this.bg = ABCyaPhaser.Images.addImage(0,0, bg, this);

    this.text = ABCyaPhaser.Text.addText(0,0,fontSize, 0xffffff, FontKeys._bpreplaybold, text, this).setOrigin(0.5);

    ABCyaPhaser.Container.setContainerInteractive(this, false);
  }

  updateButton(bg, text, fontSize) {
    this.bg.setFrame(bg);
    this.text.text = text;
    this.text.setFontSize(fontSize);
  }
}